import { ChangeDetectionStrategy, Component, Directive, Input, ViewEncapsulation } from '@angular/core';
import {
    MAT_ACCORDION,
    MatExpansionPanel,
    MatExpansionPanelState,
    matExpansionAnimations,
} from '@angular/material/expansion';

/** Coerces a data-bound value (typically a string) to a boolean. */
function coerceBooleanProperty(value: any): boolean {
    return value != null && `${value}` !== 'false';
}

/** MatExpansionPanel's states. */
export type AumExpansionPanelState = 'filled' | 'default';

@Component({
    styleUrls: ['./expansion-panel.scss'],
    selector: 'aum-expansion-panel',
    exportAs: 'matExpansionPanel',
    templateUrl: './expansion-panel.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    inputs: ['disabled', 'expanded', 'filled'],
    outputs: ['opened', 'closed', 'expandedChange'],
    animations: [matExpansionAnimations.bodyExpansion],
    providers: [
        // Provide MatAccordion as undefined to prevent nested expansion panels from registering
        // to the same accordion.
        { provide: MAT_ACCORDION, useValue: undefined },
    ],
    host: {
        class: 'mat-expansion-panel mat-elevation-z',
        '[class.mat-expanded]': 'expanded',
        '[class.aum-filled]': 'filled',
        '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
        '[class.mat-expansion-panel-spacing]': '_hasSpacing()',
    },
})
export class AumExpansionPanel extends MatExpansionPanel {
    /** Whether the Item is filled. */
    @Input()
    get filled(): any {
        return this._filled;
    }
    set filled(filled: any) {
        filled = coerceBooleanProperty(filled);

        // Only emit events and update the internal value if the value changes.
        if (this._filled !== filled) {
            this._filled = filled;
        }
    }
    private _filled = false;

    /** Gets the filled state string. */
    _getFilledState(): AumExpansionPanelState {
        return this.filled ? 'filled' : 'default';
    }

    override _getExpandedState(): MatExpansionPanelState {
        return this.expanded ? 'expanded' : 'collapsed';
    }
}

/**
 * `<aum-panel-options>`
 *
 * This directive is to be used inside of the MatExpansionPanelHeader component.
 */
@Directive({
    selector: 'aum-panel-options',
    host: {
        class: 'aum-expansion-panel-header-options',
    },
})
export class AumExpansionPanelOptions {}
